// Dokumente aus dem Archiv (Paperless) öffnen – immer über den Backend-Proxy.
// - Im Browser: neuer Tab. Der Tab muss direkt im Klick geöffnet werden (Popup-Blocker); die Adresse wird danach
//   gesetzt: ein Kurzzeit-Link (2 Minuten, nur dieses Dokument) statt des Anmeldetokens.
// - Als installierte App (Home-Bildschirm, v. a. iPhone): eigene Ansicht in der App mit „Schließen“ –
//   dort gibt es keine Browserleiste, ein im App-Fenster geöffnetes PDF wäre eine Sackgasse.
import apiService from './apiService';
import { getSessionToken } from './authService';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';
export const ARCHIVE_VIEWER_EVENT = 'archive-viewer-open';

export const archiveDocId = (value) => String(value).match(/(?:^|documents\/)(?:paperless_)?(\d+)/)?.[1] || null;
export const archiveDownloadUrl = (docId) => `/api/paperless/documents/${archiveDocId(docId)}/download`;

/** Läuft die App als installierte Web-App (ohne Browserleiste)? */
export function isStandaloneApp() {
  try {
    return window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
  } catch {
    return false;
  }
}

/** Datei über den Proxy laden (mit Anmelde-Header) → { blob, mimetype, filename } */
export async function fetchArchiveFile(docId) {
  const token = await getSessionToken();
  const response = await fetch(`${API_BASE_URL}/paperless/documents/${archiveDocId(docId)}/download`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
  if (!response.ok) {
    let message = 'Das Dokument konnte nicht geladen werden.';
    try { message = (await response.json()).error || message; } catch { /* kein JSON */ }
    throw new Error(message);
  }
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const plain = disposition.match(/filename="?([^";]+)"?/i)?.[1];
  let filename = plain || `Dokument-${archiveDocId(docId)}.pdf`;
  try { if (encoded) filename = decodeURIComponent(encoded); } catch { /* Rohname behalten */ }
  return { blob, mimetype: response.headers.get('Content-Type') || blob.type, filename };
}

const page = (text) => '<!doctype html><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">'
  + `<title>${text}</title><body style="font-family:system-ui,sans-serif;display:grid;place-items:center;height:100vh;margin:0;padding:16px;color:#52647c;text-align:center">`
  + `<p>${text}</p></body>`;

/** Archiv-Dokument öffnen; url = download_url aus der Suche oder Dokument-ID */
export function openArchiveDocument(url, title = '') {
  const docId = archiveDocId(url);

  if (isStandaloneApp()) {
    window.dispatchEvent(new CustomEvent(ARCHIVE_VIEWER_EVENT, { detail: { docId, title } }));
    return;
  }

  const win = window.open('', '_blank');
  try { win?.document.write(page('Dokument wird aus dem Archiv geladen …')); } catch { /* egal */ }

  apiService.post(`/paperless/documents/${docId}/link`, {})
    .then(({ url: link }) => {
      if (win && !win.closed) win.location.replace(link);
      // Fenster blockiert: Ansicht in der App statt das App-Fenster wegzunavigieren
      else window.dispatchEvent(new CustomEvent(ARCHIVE_VIEWER_EVENT, { detail: { docId, title } }));
    })
    .catch(() => {
      const message = navigator.onLine
        ? 'Das Dokument konnte nicht geöffnet werden. Bitte später erneut versuchen.'
        : 'Archiv-Dokumente lassen sich nur mit Internetverbindung öffnen.';
      try { win?.document.open(); win?.document.write(page(message)); win?.document.close(); } catch { /* egal */ }
    });
}
